<!--
 * @Author: your name
 * @Date: 2020-09-15 17:11:34
 * @LastEditTime: 2020-09-24 10:40:34
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\pages\rc\io\configsearch.vue
-->
<template>
    <div class="searchContent">
        <a-affix>
            <a-card :title="this.$slots.default">
                <a-form layout="inline" @submit="handleSubmit" :form="form">
                    <a-form-item label="系统名称">
                        <a-input
                            v-decorator="[
                                'systemname',
                                {
                                    initialValue: record.systemname || '',
                                }
                            ]"
                            placeholder="请输入系统名称"
                        ></a-input>
                    </a-form-item>

                    <a-form-item label="服务器IP">
                        <a-input
                            v-decorator="[
                                'serverip',
                                {
                                    initialValue: record.serverip || '',
                                }
                            ]"
                            placeholder="请输入服务器IP"
                        ></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button
                            type="primary"
                            htmlType="submit"
                            :key="this.loading.key"
                            :loading="this.loading.effects[selectType]"
                        >查询</a-button>
                        <v-resetbutton
                            :key="Math.random()"
                            :loading="this.loading.effects[selectType]"
                            :redirect="{path:`/${storeNamespace}/config`}"
                            class="ml15"
                        >重置</v-resetbutton>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-affix>
    </div>
</template>

<script>
const storeNamespace = "rc/io";

export default {
    data() {
        return {
            storeNamespace,
            selectType: `${storeNamespace}/configlist`,
            form: this.$form.createForm(this),
            record: this.$route.query || {},
        };
    },
    computed: {},
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                this.$router.push({
                    query: values
                });
            });
        }
    },
    beforeMount() {},
    mounted() {}
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-bottom: 20px;
}
</style>
